import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
  Label,
  Button,
  Alert,
  InputGroup,
  Input,
} from "reactstrap";
import Draggable from "react-draggable";
import { IoCheckmark, IoCopyOutline } from "react-icons/io5";

import { GetLanguageString } from "../helper/Components";

const UsersCredential = ({ setModal, setValues, values }) => {
  const [copiedType, setCopiedType] = useState(null); // 'username' | 'password' | 'all' | null
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const toggle = () => {
    setModal(false);
    setValues({ id: "", username: "", password: "" });
  };

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const handleCopy = (text, type) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopiedType(type);
    setTimeout(() => {
      setCopiedType((prev) => (prev === type ? null : prev));
    }, 2500);
  };

  const copyUsername = () => {
    handleCopy(values?.username || "", "username");
  };

  const copyPassword = () => {
    handleCopy(values?.password || "", "password");
  };

  const copyAll = () => {
    handleCopy(
      "UserName : " +
        (values?.username || "") +
        "\nPassword : " +
        (values?.password || ""),
      "all"
    );
  };

  return (
    <div>
      <Draggable
        position={position}
        onDrag={handleDrag}
        handle=".modal-header"
        cancel=".no-drag, input, button, a"
      >
        <Modal isOpen={true} className="inmodal">
          <ModalHeader
            className="modal-title"
            tag="h4"
            style={{ cursor: "move" }}
          >
            {<GetLanguageString props="users_credential" />}
          </ModalHeader>
          <Form onSubmit={(e) => e.preventDefault()}>
            <ModalBody>
              <FormGroup className="mb-3">
                <Label className="fw-bold mb-1">
                  {<GetLanguageString props="user_user_name" />}
                </Label>
                <InputGroup className="no-drag">
                  <Input
                    type="text"
                    readOnly
                    value={values?.username || ""}
                    className="no-drag"
                    style={{
                      backgroundColor: "#f8f9fa",
                      cursor: "text",
                      userSelect: "text",
                    }}
                    onFocus={(e) => e.target.select()}
                  />
                  <Button
                    type="button"
                    color={copiedType === "username" ? "success" : "white"}
                    className="no-drag d-flex align-items-center justify-content-center"
                    style={{ minWidth: "42px" }}
                    onClick={copyUsername}
                    title="Copy Username"
                  >
                    {copiedType === "username" ? (
                      <IoCheckmark size={18} className="text-white" />
                    ) : (
                      <IoCopyOutline size={18} />
                    )}
                  </Button>
                </InputGroup>
              </FormGroup>

              <FormGroup className="mb-3">
                <Label className="fw-bold mb-1">
                  {<GetLanguageString props="user_password" />}
                </Label>
                <InputGroup className="no-drag">
                  <Input
                    type="text"
                    readOnly
                    value={values?.password || ""}
                    className="no-drag"
                    style={{
                      backgroundColor: "#f8f9fa",
                      cursor: "text",
                      userSelect: "text",
                    }}
                    onFocus={(e) => e.target.select()}
                  />
                  <Button
                    type="button"
                    color={copiedType === "password" ? "success" : "white"}
                    className="no-drag d-flex align-items-center justify-content-center"
                    style={{ minWidth: "42px" }}
                    onClick={copyPassword}
                    title="Copy Password"
                  >
                    {copiedType === "password" ? (
                      <IoCheckmark size={18} className="text-white" />
                    ) : (
                      <IoCopyOutline size={18} />
                    )}
                  </Button>
                </InputGroup>
              </FormGroup>

              {copiedType ? (
                <Alert color="success" className="py-2 mb-0 text-center">
                  <GetLanguageString props="users_credential_copied_to_clipboard" />
                </Alert>
              ) : null}
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={toggle} type="button">
                {<GetLanguageString props="common_cancel" />}
              </Button>
              <Button color="white" onClick={copyAll} type="button">
                <IoCopyOutline className="me-1" size={16} />{" "}
                {<GetLanguageString props="user_copy_button" />}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Draggable>
    </div>
  );
};

export default UsersCredential;
